// libs
import React from 'react';
import { useLocation } from 'react-router-dom';
// dls
import { Image } from '@swiggy-private/dls-web-core/dist/components/Image';
// components
import { UserAvatar } from './components/UserAvatar';
// constants
import { DISALLOWED_ROUTES, IMAGE_CONFIG } from '@/widgets/Header/constants';
// styles
import styles from './Header.module.scss';
const Header = ({ user }) => {
    const location = useLocation();
    if (Object.keys(DISALLOWED_ROUTES).includes(location.pathname)) {
        return null;
    }
    const handleSignOut = () => {
        // handle signout logic
    };
    return (React.createElement("nav", { className: styles.header },
        React.createElement(Image, { className: styles.logo, cloudinaryId: IMAGE_CONFIG.cloudinaryId, alt: IMAGE_CONFIG.alt, cloudinaryHeight: IMAGE_CONFIG.dimension * 2, cloudinaryWidth: IMAGE_CONFIG.dimension * 4, height: `${IMAGE_CONFIG.dimension}px`, width: `${IMAGE_CONFIG.dimension * 2}px` }),
        React.createElement("div", { className: styles.headerContent },
            React.createElement(UserAvatar, { user: user, onSignOut: handleSignOut }))));
};
export default Header;
